"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _InputWithUnit = _interopRequireDefault(require("../InputWithUnit"));

var _roundOnBlur = _interopRequireDefault(require("./utils/roundOnBlur"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Container = _styledComponents.default.span(_templateObject());

Container.displayName = 'Container';

var DurationInput = function DurationInput(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      minHours = _ref.minHours,
      maxHours = _ref.maxHours,
      step = _ref.step,
      name = _ref.name,
      onBlur = _ref.onBlur,
      inDays = _ref.inDays,
      minDays = _ref.minDays,
      maxDays = _ref.maxDays,
      gaAction = _ref.gaAction,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["onChange", "value", "minHours", "maxHours", "step", "name", "onBlur", "inDays", "minDays", "maxDays", "gaAction", "className"]);

  if (inDays) {
    props.gaAction = gaAction + " days";
    return _react.default.createElement(_InputWithUnit.default, _extends({}, props, {
      className: className,
      type: "number",
      name: name + ".days",
      onChange: onChange,
      max: maxDays,
      min: minDays,
      step: step,
      onBlur: (0, _roundOnBlur.default)({
        onBlur: onBlur,
        onChange: onChange,
        step: step,
        allowNegative: minDays < 0
      }),
      value: value.days,
      unit: "days",
      gaTrackValue: true
    }));
  }

  var gaActionHours = {
    gaAction: gaAction + " hours"
  };
  var gaActionMinutes = {
    gaAction: gaAction + " minutes"
  };
  return _react.default.createElement(Container, {
    className: className
  }, _react.default.createElement(_InputWithUnit.default, _extends({}, props, gaActionHours, {
    className: "mr-1",
    type: "number",
    name: name + ".hours",
    onChange: onChange,
    max: maxHours,
    min: minHours,
    step: "1",
    onBlur: (0, _roundOnBlur.default)({
      onBlur: onBlur,
      onChange: onChange,
      step: 1,
      allowNegative: minHours < 0
    }),
    value: value.hours,
    unit: "hrs"
  })), _react.default.createElement(_InputWithUnit.default, _extends({}, props, gaActionMinutes, {
    type: "number",
    name: name + ".minutes",
    value: value.minutes,
    onChange: onChange,
    step: step,
    min: "0",
    max: 60 - +step,
    onBlur: (0, _roundOnBlur.default)({
      onBlur: onBlur,
      onChange: onChange,
      step: step
    }),
    unit: "mins"
  })));
};

DurationInput.displayName = 'DurationInput';
DurationInput.propTypes = {
  maxHours: _propTypes.string,
  maxDays: _propTypes.string,
  minHours: _propTypes.string,
  minDays: _propTypes.string,
  value: (0, _propTypes.shape)({
    hours: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
    minutes: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
  }).isRequired,
  step: _propTypes.string,
  onChange: _propTypes.func.isRequired,
  onBlur: _propTypes.func,
  name: _propTypes.string,
  inDays: _propTypes.bool,
  gaAction: _propTypes.string,
  className: _propTypes.string
};
DurationInput.defaultProps = {
  gaAction: '',
  maxHours: '168',
  maxDays: '366',
  minHours: '0',
  minDays: '0',
  step: '5',
  name: 'duration',
  onBlur: function onBlur() {},
  inDays: false,
  className: ''
};
var _default = DurationInput;
exports.default = _default;